import { render, staticRenderFns } from "./Revisit.vue?vue&type=template&id=f716d188&scoped=true"
import script from "./Revisit.vue?vue&type=script&lang=js"
export * from "./Revisit.vue?vue&type=script&lang=js"
import style0 from "./Revisit.vue?vue&type=style&index=0&id=f716d188&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f716d188",
  null
  
)

export default component.exports